import { ComponentIds } from '@inter-ikea-core/core';
import { PlannerEcsSystem } from './System';
/**
 * This system listens to updates on LoadedModelInfoComponent.
 * When a model has finished loading, it will trigger CoreApi
 * event subscribers for 'modelLoaded'
 */
export class ModelLoadedEventSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'ModelLoadedEventSystem', ComponentIds.LOADED_MODEL_INFO_COMPONENT_ID);
    }
    onAdd(entity, newComponent) {
        this.onModelFinishedLoading(entity, newComponent);
    }
    onUpdate(entity, oldComponent, newComponent) {
        this.onModelFinishedLoading(entity, newComponent);
    }
    onRemove() { }
    /**
     * Checks if model has finished loading and triggers event
     * subscribers for 'modelLoaded'
     */
    onModelFinishedLoading(entity, newComponent) {
        if (!newComponent || !newComponent.hasFinishedLoading) {
            return;
        }
        this.coreApi.emit.onModelLoaded(entity.id);
        const allModelsLoaded = this.coreApi
            .getServices()
            .sceneManager.entities.filter(e => !e.hasComponent(ComponentIds.ROOM_PART_COMPONENT_ID) &&
            !e.hasComponent(ComponentIds.SCENE_COMPONENT_ID))
            .every(e => e.getComponent(ComponentIds.LOADED_MODEL_INFO_COMPONENT_ID)
            ?.hasFinishedLoading);
        if (allModelsLoaded) {
            this.coreApi.emit.onAllModelsLoaded();
        }
    }
}
//# sourceMappingURL=ModelLoadedEventSystem.js.map